import { siteTypes } from "./types";

// SITE ACTIONS

export const SetDevices = (data) => ({
  type: siteTypes.SET_DEVICES,
  payload: data,
});

export const SetSelectedDevice = (device) => ({
  type: siteTypes.SET_SELECTED_DEVICE,
  payload: device,
});

export const SetMapDisplay = (bool) => ({
  type: siteTypes.SET_MAP_DISPLAY,
  payload: bool,
});

export const SetMapOption = (mapData) => ({
  type: siteTypes.SET_MAP_OPTION,
  payload: mapData,
});

export const SetHistory = (data) => ({
  type: siteTypes.SET_HISTORY,
  payload: data,
});
